export default {
  step1: [
    {
      id: 1,
      step: 1,
      stepJp: "地金",
      name: "K18YG（イエロー）",
      hex: "#F4F3DF",
      property: "base",
      val: "K18YG",
      summary: "年令を問わずつけやすく、飽きのこない色です。どのデザインにもよく合う地金で、強度もあり手入れしやすいです。",
      // price:65000,
    },
    {
      id: 2,
      step: 1,
      stepJp: "地金",
      name: "K18GG（グリーン）",
      hex: "#E9F4DF",
      property: "base",
      val: "K18GG",
      summary:"個性的で人とは違ったマリッジリングになります。柔らかい18 金地金ですので、傷が気になりにくいテクスチャーがおすすめ。",
      // price:65000,
    },
    {
      id: 3,
      step: 1,
      stepJp: "地金",
      name: "K18PG（ピンク）",
      hex: "#F4E6DF",
      property: "base",
      val: "K18PG",
      summary:"とても肌なじみの良い色で、男性でも着けやすいゴールド色です。硬さのある地金ですので、細身のリングにおすすめです。",
      // price:65000,
    },
    {
      id:4,
      step: 1,
      stepJp: "地金",
      name: "K18CG（シャンパン）",
      hex: "#EFEEE1",
      property: "base",
      val: "K18CG",
      summary:"ややゴールド味のあるホワイト系18 金。肌なじみが良く、どのデザインにもよく合うので人気の高い地金です。",
      // price:75000,
    },
    {
      id: 5,
      step: 1,
      stepJp: "地金",
      name: "K18WG（ホワイト）",
      hex: "#F2F2F0",
      property: "base",
      val: "K18WG",
      summary:"プラチナより少しブラウンがかったナチュラルな色です。どのデザインにもよく合う色です。",
      // price:75000,
    },
    {
      id:6,
      step: 1,
      stepJp: "地金",
      name: "K18GY（グレー）",
      hex: "#E6E6E6",
      property: "base",
      val: "K18GY",
      summary:"ホワイトゴールドよりも黒みがかったホワイト系18 金となります。重圧感のあるリングに仕上がります。",
      // price:88000,
    },
    {
      id:7,
      step: 1,
      stepJp: "地金",
      name: "K20YG（イエロー）",
      hex: "#EAEBCA",
      property: "base",
      val: "K20YG",
      summary:"純度の高いゴールドで、人気が高いです。肌が敏感な方にもおすすめです。18 金イエローをやや濃くしたような色味です。",
      // price:80000,
    },
    {
      id:8,
      step: 1,
      stepJp: "地金",
      name: "K20PG (ピンク)",
      hex: "#EBDBD3",
      property: "base",
      val: "K20PG",
      summary:"純度の高いゴールド。K18 ピンクに比べてややオレンジがかっています。高級感のある華やかな色味で、肌なじみも良いです。",
      // price:88000,
    },
    {
      id:9,
      step: 1,
      stepJp: "地金",
      name: "Pt（プラチナ）",
      hex: "#F8F8F8",
      property: "base",
      val: "PT",
      summary:"重厚で高級感のある白い地金です。硬さがある「ハードプラチナ950」または「プラチナ900」をデザインにより使用しています。",
      // price:88000,
    }
  ]
}
